import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { List } from "immutable";
import { MenuItem } from "../../../../shared/menu/menu-item.model";
import { ArrayHelper } from "../../../../utilities/contracts/array-helper";
import { StringHelper } from "../../../../utilities/contracts/string-helper";
import { AnalyticsHedisService } from "../analytics-hedis/analytics-hedis.service";

@Component({
  selector: "app-analytics-menu-header",
  templateUrl: "./analytics-menu-header.component.html",
  styleUrls: ["./analytics-menu-header.component.scss"],
})
export class AnalyticsMenuHeaderComponent {
  @Input() menuHeaderItems: MenuItem[] | List<MenuItem> = [];
  menuItems = List<MenuItem>();
  selectedMenuHeader: string;

  constructor(
    private analyticsHedisService: AnalyticsHedisService,
    private changeDetector: ChangeDetectorRef
  ) { }

  get hasMenuHeaderItems(): boolean {
    return ArrayHelper.isAvailable(this.menuHeaderItems);
  }

  get filteredMenuHeaderItems(): List<MenuItem> {
    const items = this.hasMenuHeaderItems ? (this.menuHeaderItems as any).filter(item => item.show) : [];
    return List(items);
  }

  onHeaderMenuClick(headerItem: MenuItem): void {
    this.selectedMenuHeader = headerItem.description;
  }

  assignAndNotify<T>(data: T[]): List<T> {
    this.changeDetector.markForCheck();
    const items = List(data);
    return items;
  }

  get selectedTab(): string {
    return StringHelper.isAvailable(this.selectedMenuHeader) ? this.selectedMenuHeader : "Overview";
  }

  selectedTabs(tabName: string, isFirstElement: boolean): string {
    let className = "header-btn";
    if (isFirstElement) {
      className += " header-btn-first-menu-element";
    }
    if (this.selectedTab === tabName) {
      className += " header-btn-first-element";
    }
    return className;
  }

  trackByIndex(index, item) {
    return index;
  }
}
